import type { Resource } from '../../';
export const returns_exchangeMode_activeAlert: Resource = {"default":"You are selecting an item for exchange."};
